export default __webpack_public_path__ + "media/icons/pro-badge-white-bg-848d1c80.svg";